<template>
  <article class="barriergate_process_dedail">
    <div class="createflow-car-info" v-if="detailData.image_url">
      <img :src="detailData.image_url" alt="">
      <p class="plate-number">
        <span class="name">
        {{ phone_number }}
        <!-- 无牌用fromVin -->
        {{notPlate ? fromVin : detailData.vin }}
        {{!phone_number && !(notPlate ? fromVin : detailData.vin) ? detailData.plate_number : ''}}
        </span>
      </p>
    </div>
    <div class="createflow-car-info none-car-pic" v-else>
      <p class="tip-info">未抓拍到图片</p>
      <p class="plate-number">
        <span class="name">
        {{phone_number}} &nbsp;
        <!-- 无牌用fromVin -->
        {{notPlate ? fromVin : detailData.vin }}
        {{!phone_number && !(notPlate ? fromVin : detailData.vin) ? detailData.plate_number : ''}}
        </span>
      </p>
    </div>
    <h2 class="title-bar">当前审核进程</h2>
    <div class="process_list">
      <ul class="flow">
        <li v-for="(item, index) in detailData.exiting_steps" :key="index">
          <div class="status_icon align_title">
            <i class="status_line" :class="{'status_line_blue': item.status_code !== 'not_started'}"></i>
            <i class="icon" :class="iconClass[item.status_code]"></i>
          </div>
          <div class="status_info">
            <div>
              <p>{{item.step_no === 1 ? '发起人' : item.title}}</p>
              <p v-if="item.operator">{{item.operator}}</p>
              <p v-else v-for="(v, i) in item.review_employee_choices" :key="i">{{v.employee_name}}</p>
              <p v-if="item.status_code === 'rejected' && item.reject_reason">驳回原因: {{item.reject_reason}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <h2 class="title-bar">放行备注</h2>
    <div class="process_remark">
      <p
        v-if="detailData.exiting_comment"
        :class="{'p--notbottom': getNotShowBottom(detailData)}"
      >
        {{ detailData.exiting_comment }}
      </p>
      <span v-if="detailData.remark" class="process_remark-span">{{detailData.remark}}</span>
      <div
        v-if="detailData.workflow_image_urls && detailData.workflow_image_urls.length"
        class="process_images"
      >
        <img
          v-for="item in detailData.workflow_image_urls"
          :key="item.image"
          :src="item.thumbnail_image"
          @click="handleImageClick(item.image)"
        />
      </div>
    </div>
    <section class="btn-bottom"  v-if="detailData.can_renew_exiting_process">
      <div class="btn-fix">
        <a href="javascript:void(0);" class="btn"  @click.stop="onReCreate">重新发起审核</a>
      </div>
    </section>
    <section class="btn-bottom submit-btn" v-else-if="pendingReview">
      <div class="btn-fix">
        <a class="btn" @click="handleShowReject('reject', step_id)">驳回</a>
        <a class="btn" @click="onUpdate('approve', step_id)">同意</a>
      </div>
    </section>
    <section class="btn-bottom submit-btn" v-else-if="detailData.retreatable">
      <div class="btn-fix">
        <a class="btn" @click="showCancelConfirm=true">撤回放行申请</a>
      </div>
    </section>
    <Confirm
      title="您确认撤回当前车辆放行吗？"
      cancelText="取消" confirmText="确定"
      v-model="showCancelConfirm"
      @on-cancel="show=false"
      @on-confirm="onWithdrawComfirm"
    ></Confirm>
    <RejectReasonConfirm
      @success="handleReject"
      ref="rejectReasonConfirm"
    />
     <Alert
      ref="checkListAlertRef"
      :title="alertInfo.title"
      confirmText='确认'
    >
      <div class="reject-confirm__text">{{alertInfo.text}}</div>
    </Alert>
  </article>
</template>
<script>
import { Confirm } from '@lx-frontend/cvux'
import RejectReasonConfirm from '../components/RejectReasonConfirm.vue'
import { CarStatus } from '@/common/commonType'
import Alert from '../components/Alert.vue'

export default {
  components: { Confirm, RejectReasonConfirm, Alert },
  data() {
    return {
      id: 0,
      iconClass: {
        pending_review: 'status_waiting',
        approved: 'status_ok',
        rejected: 'status_no',
        canceled: 'status_no',
        not_started: 'original'
      },
      detailData: {},
      step_id: '',
      employeeId: [],
      authId: '', // 权限用户
      pendingReview: false, // 审核中
      show: false,
      showCancelConfirm: false,
      isChecking: false, // 防止重复提交
      notPlate: true, // 有牌无牌
      rejectReason: '',
      alertInfo: {
        title: '',
        text: ''
      },
      phone_number: '',
      fromVin: ''
    }
  },
  created() {
    this.initData()
  },
  methods: {
    getNotShowBottom (detailData) {
      return (!detailData.workflow_image_urls || detailData.workflow_image_urls.length === 0) && !detailData.remark
    },
    handleImageClick(current) {
      this.$wechat.wx.previewImage({
        current,
        urls: this.detailData.workflow_image_urls.map(item => item.image)
      })
    },
    async initData() {
      const auth = await this.$store.state.promiseAuth
      this.authId = auth.id
      const { process_id, id } = this.$route.params
      const { notPlate, phone_number = '', vin = '' } = this.$route.query
      let processId = process_id
      this.id = id
      this.notPlate = Boolean(+notPlate)
      this.phone_number = phone_number
      this.fromVin = vin
      this.$rest.barriergate.getFlowDetail({
        process_id: processId,
        time: new Date().getTime()
      }, `${this.id}/exiting/process/view`).then((res) => {
        if (res.code === 0) {
          this.detailData = res.data
          this.pendingReview = res.data.exiting_steps.some(v => {
            let pendingReview = ((v.status_code === 'pending_review') && v.step_id)
            let hasEmployeeId = false
            if (pendingReview) {
              this.step_id = v.step_id
              hasEmployeeId = v.review_employee_choices.some(item => {
                return this.authId === item.employee_id
              })
            }
            return pendingReview && hasEmployeeId
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    async onReCreate() {
      if (this.notPlate) {
        const { brand_id = '' } = this.detailData
        const query = {
          // 根据后端这里使用列表的vin
          vin: this.fromVin,
          phone_number: this.phone_number,
          brand_id
        }
        this.$router.push({
          path: '/leaveRegisterNotPlate/index',
          query
        })
        return
      }
      if (this.detailData.plate_number.includes('无P')) {
        this.$router.push('/leaveRegisterNotPlate/index')
        return
      }
      this.$router.push(`/barriergate/create/${this.id}`)
    },
    handleShowReject(status, id) {
      this.$refs.rejectReasonConfirm.changeShow(true, { status, id })
    },
    handleReject({ reason, backInfo }) {
      this.rejectReason = reason
      const { status, id } = backInfo
      this.onUpdate(status, id)
    },
    onRejectConfirm() {
      const { status, id } = this.rejectedInfo
      this.onUpdate(status, id)
    },

    onUpdate(status, id) {
      if (this.isChecking) {
        return false
      }
      this.isChecking = true
      this.show = false
      let statusUpdate = ''
      const params = {
        action: status
      }
      switch (status) {
        case 'reject':
          statusUpdate = '已驳回'
          params.reason = this.rejectReason
          break
        case 'approve':
          statusUpdate = '已通过'
          break
        default:
          statusUpdate = '已驳回'
      }
      const { exiting_process_id: processId } = this.detailData
      this.$rest.barriergate.updateCheckState(params, `${processId}/steps/${id}/${status}`).then((res) => {
        if (res.code === 0) {
          this.initData()
          /***
          ** 已驳回或已通过，隐藏操作按钮。隐藏逻辑（如果同时是审核人，驳回后则应回到重新发起审核状态）
          ***/
          this.pendingReview = false
          this.showToast(statusUpdate)
        } else {
          this.showToast(res.message)
        }
        this.isChecking = false
      })
    },
    showModal() {
      this.show = true
    },
    onWithdrawComfirm() {
      const notPlate = this.notPlate || this.detailData.plate_number.includes('无P')
      const id = this.detailData.exiting_process_id
      const visitId = this.$route.params.id
      const processId = this.$route.params.process_id
      this.$rest.barriergate.callBackReleaseApply('', `${id}/exiting/process/retreate`)
        .then(res => {
          let params = ''
          // let params = { status: 1, id, retryBtn: true, message: '已撤回' }
          // let params = { status: 0, id, viewProcessBtn: true, message: '已经审核，无法撤回', process_id: processId }
          if (res.code === 0) {
            params = { status: 1, id: visitId, retryBtn: true, message: '已撤回' }
          } else if (res.code === -1) {
            params = { status: 0, id: visitId, viewProcessBtn: true, message: '已经审核，无法撤回', process_id: processId }
          } else if (res.message) {
            this.showToast(res.message)
          }
          if (params) {
            params.notPlate = notPlate ? '1' : ''
            this.$router.push({
              path: '/barriergate/action_result',
              query: params
            })
          }
        })
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/barriergate/creatFlow.less";
@import "../../stylesheets/modules/components/flow.less";

/** 单独修改当前进度条样式 */
.flow {
  .status_icon {
    i.status_line {
      background-color: #d9d9d9;
    }
    i.icon {
      top: 46/@w2;
      z-index: 10;
    }
    i.original {
      width: 15/@w2;
      height: 15/@w2;
      background-color: #d9d9d9;
      .radius(50%);
    }
    i.status_waiting,
    i.status_ok,
    i.status_no {
      width: 20/@w2;
      height: 20/@w2;
    }
    i.status_ok {
      background-position: 0 -297/@w2;
    }
    i.status_no {
      background-position: 0 -269/@w2;
    }
    i.status_waiting {
      background-position: 0 -325/@w2;
    }
  }

  li:nth-child(1) {
    .status_icon .status_line,
    .status_icon i.icon {
      top: 46/@w2;
    }
  }
}

.process_images {
  display: flex;
  padding: 0.3rem 0 0.4rem;
  img {
    margin-right: 20px;
    width: 2.667rem;
    height: 1.773rem;
    object-fit: cover;
    border-radius: 0.04rem;
  }
}
</style>
